import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-conmet-input-number',
  styleUrls: ['./conmet-input-number.component.scss'],
  template: `
    <div class='d-flex' *ngIf='label'>
      <label *ngIf='label'>{{ label }}</label>
      <label *ngIf='!label'>&nbsp;</label>
    </div>
    <div class='d-flex' [formGroup]='_group'>
      <input class='form-control {{validationCheckFunc()}}' type='text' [attr.placeholder]='label' [formControlName]='_formname' [attr.disabled]='disable ? disable : null' style="display: none;"/>
    </div>
    <div class='d-flex'>
      <input class='form-control {{validationCheckFunc()}}' type='text' [attr.placeholder]='label' [attr.disabled]='disable ? disable : null' [(ngModel)]="_number" (keyup)="check()" (blur)="write()"/>
    </div>

    <!--      (change)="check()"  -->
    <!--      pattern="^[0-9]+(?:\\\\,[0-9]{1,2})?$"  -->
  `
})
export class ConmetInputNumberComponent implements OnInit {
  @Input() set group(group: FormGroup) {
    this._group = group;
    this.onChanges();
  }

  @Input() set formname(formname: string) {
    this._formname = formname;
    this.onChanges();
  }

  // @Input() group: FormGroup;
  // @Input() formname: string;
  @Input() label: string;
  @Input() disable: string;
  @Input() validation: boolean;
  @Input() validationCheck: boolean;
  @Input() decimali: number;

  _group: FormGroup;

  _formname: string;
  _app: string;

  _number: string;

  constructor() {
    this.disable = null;
    this.decimali = 2;

    this.onChanges();
  }

  ngOnInit() {
  }

  validationCheckFunc() {
    if (this.validation) {
      return this.validationCheck ? 'is-valid' : 'is-invalid';
    }

    return '';
  }

  check() {
    const re = /^-?(?:\d+|\d{1,3})(?:(\.|,)?)(\d*)$/;

    // sostituisco il punto con la virgola
    if (this._number) {
      this._number = this._number.replace('.', ',');

      if (this._number.split(',').length - 1 > 1) {
        this._number = this._number.substring(0, this._number.indexOf(',')) + this._number.substring(this._number.indexOf(',') + 1, this._number.length);
      }

      // testo i caratteri inseriti (solo numeri e . o ,)
      if (!re.test(this._number)) {
        this._number = this._number.substring(0, this._number.length - 1);
      }

      if (this.decimali > 0) {
        // controllo i decimali
        if (this._number.indexOf(',') > 0 && this._number.substring(this._number.indexOf(',') + 1, this._number.length).length > 2) {
          this._number = this._number.substring(0, this._number.indexOf(',')) + this._number.substring(this._number.indexOf(','), this._number.indexOf(',') + (1 + this.decimali));
        }
      } else {
        if (this._number.indexOf(',') > 0) {
          this._number = this._number.substring(0, this._number.indexOf(','));
        }
      }
    }
  }

  write() {
    const obj = {};

    obj[this._formname] = this._number.replace(',', '.');

    this._group.patchValue(obj);
  }

  onChanges(): void {
    if (this._group && this._formname) {
      this._group.valueChanges.subscribe(val => {

        this._number = this._group.value[this._formname].toString().replace('.', ',');

        // if (this._app !== this._group.value[this._formname].toString()) {
        //
        //   console.log('change!');
        //
        //   console.log(this._app);
        //   console.log(this._group.value[this._formname]);
        //   console.log(this._group.value[this._formname].toString());
        //
        //   const namen = this._formname,
        //     value = this._group.value[this._formname].toString().replace('.', ',');
        //
        //   console.log(namen);
        //   console.log(value);
        //
        //   const re = /^[0-9]+(?:\\,[0-9]{1,2})?$/;
        //
        //   // console.log(this._group.value[this._formname]);
        //   console.log(re.test(this._group.value[this._formname]));
        //   // this._app = value;
        //
        //   this._app = this._group.value[this._formname].toString();
        //
        //
        //   this._group.patchValue({namen: value});
        //   //
        //   //   // this._group.value[this._formname] = this._group.value[this._formname].replace('.', ',');
        //   //
        //
        //
        //   console.log('----------------------------------------------------');
        // }
      });
    }
  }
}
